import { BoxedQuantityControl } from "./BoxedQuantityControl";
import { CircleQuantityControl } from "./CircleQuantityControl";

export function QuantityControl(props) {
  const { variant } = props;
  if (variant === "boxed") {
    return <BoxedQuantityControl {...props} />;
  }
  return <CircleQuantityControl {...props} />;
}
